import React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import SystemView from './SystemView';

const SystemModule = () => {
  return (
    <ContainerTemplate active={ROUTES.system} routes={[ROUTES.root]}>
      <SystemView />
    </ContainerTemplate>
  );
};

export default SystemModule;
